module.exports = __webpack_public_path__ + "img/podcast-trailer.a9f5ad66.png";